//==========================================================================
// reason.js
//==========================================================================

function initCommentSlider() {
  const slickOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    dots: true,
    arrows: false,
    infinite: false
  };

  function checkSlider() {
    $('.js-voice_slider').each(function () {
      const $slider = $(this);

      if ($(window).width() <= 767) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick(slickOptions);
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    });
  }

  checkSlider();
  $(window).on('resize orientationchange', checkSlider);
}


//------------------------------
$(function () {
  initCommentSlider();
});
